import { IChatSession } from '@/bundles/AiAgent/types';
import BasePostgresModel from '@/bundles/App/models/BasePostgresModel';

export default class ChatSession extends BasePostgresModel implements IChatSession {
  title: string | null;
  summary: string | null;
  last_record_type: string | null;
  last_filters: Record<string, any>;
  message_count: number;
  created_at: Date;
  last_message_at: Date | null;

  constructor (payload: IChatSession) {
    super(payload);
    this.title = payload.title;
    this.summary = payload.summary;
    this.last_record_type = payload.last_record_type;
    this.last_filters = payload.last_filters || {};
    this.message_count = payload.message_count;
    this.created_at = new Date(payload.created_at);
    this.last_message_at = payload.last_message_at ? new Date(payload.last_message_at) : null;
  }
}
